import { renderApp } from "./render-app";
import { renderOfflineShell } from "./render-offline-page";

export const retryConnection = async () => {
  await renderOfflineShell({ isChecking: true, errorMessage: undefined });
  if (!navigator.onLine) {
    await renderOfflineShell({
      isChecking: false,
      errorMessage: "Device appears to be offline.",
    });
    return;
  }

  await renderApp();
};
